import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class ComponentService extends BaseService {
	constructor() {
		super('/component');
	}

	public getRefreshById(id: number) {
		return super.getByIdWithResourceName(id, this._resourceName + '/refresh');
	}

	public getAllByFilter(filter: ComponentFilter) {
		return super.getAllByFilterBase(filter);
	}

	public stopTask(id: number) {
		return super.updateBase(this._resourceName + '/stop-task/' + id, null);
	}

	public stopProcessingTaskOnComponent(id: number) {
		return super.updateBase(this._resourceName + '/stop-processing-task-on-component/' + id, null);
	}

	public playProcessingTaskOnComponent(id: number) {
		return super.updateBase(this._resourceName + '/start-processing-task-on-component/' + id, null);
	}
	
	public acceptProvision(id: number) {
		return super.updateBase(this._resourceName + '/accept-provision/' + id, null);
	}

	public addComponent(data: any) {
		return super.updateBase(this._resourceName + '/add-component/' , data);
	}

	public acceptProvisionList(list: number[]) {
		return this.updateListWithResourceName(list, 'add-provision-list');
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}

	public activateComponent(id: number) {
		return super.updateBase(this._resourceName + '/activate/' + id, null);
	}

	public deactivateComponent(id: number) {
		return super.updateBase(this._resourceName + '/deactivate/' + id, null);
	}
}

export class ComponentFilter extends BaseFilter {
	constructor(idTenant?: number | null, isDeleted?: boolean | null, idGroup?: number | null, idTask?: number | null, notIdTask?: number | null
		, componentTypeIdentifier?: string | null, onlyComponentsInStateAcceptingTask?: boolean | null) {
		super();
		this._idGroup = idGroup;
		this._idTenant = idTenant;
		this._idTask = idTask;
		this._notIdTask = notIdTask;
		this._isDeleted = isDeleted;
		this._componentTypeIdentifier = componentTypeIdentifier;
		this._onlyComponentsInStateAcceptingTask = onlyComponentsInStateAcceptingTask;
		
	}

	private _idTenant?: number | null;
	private _idTask?: number | null;
	private _notIdTask?: number | null;
	private _isDeleted?: boolean | null;
	private _idGroup?: number | null;
	private _componentTypeIdentifier?: string | null;
	private _onlyComponentsInStateAcceptingTask?: boolean | null;
	
	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idGroup != null ? { IdGroup: this._idGroup } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._idTask != null ? { IdTask: this._idTask } : {}),
			(this._notIdTask != null ? { NotIdTask: this._notIdTask } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {}),
			(this._componentTypeIdentifier != null ? { ComponentTypeIdentifier: this._componentTypeIdentifier } : {}),
			(this._onlyComponentsInStateAcceptingTask != null ? { OnlyComponentsInStateAcceptingTask: this._onlyComponentsInStateAcceptingTask } : {})
		);

		return data;
	};
}